import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import image from "../Assests/Images/payment_success.svg";
import logo from "../Assests/Images/tfs_logo.png"

const PaymentSuccess = () => {
  return (
    <Container fluid className=" min-vh-100">
      <Row className="justify-content-center align-items-center min-vh-100 mx-0">
        <Col xs={12} md={6} lg={4} className="px-3">
        <div className="" style={{ display: 'flex', justifyContent: 'center' }}>
              <img src={logo} alt="logo" className="" style={{ height: '60px', width: '120px', marginBottom: '10px' }} />
            </div>
          <div className="text-center mb-4">
            <img 
              src={image} 
              alt="success" 
              className="img-fluid" 
              style={{ 
                maxWidth: '200px', 
                height: 'auto' 
              }} 
            />
          </div>
          
          <div className="" style={{ background: 'transparent' }}>
            <div className="p-4">
              <div className="text-center">
                <h1 className="text-success mb-3" style={{ fontSize: '2rem' }}>
                  Payment Successful!
                </h1>
                <p className="text-muted mb-4" style={{ fontSize: '1.1rem' }}>
                  Your payment has been processed successfully. Thank you for your purchase.
                </p>
                <div className="d-grid gap-2">
                  <Button 
                    variant="primary" 
                    href="/customer-login"
                    size="lg"
                    className="px-4 py-2"
                  >
                    Go to Home
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentSuccess;